import styled from 'styled-components';
import { Segment as SegmentLayoutComponent, Text as TextCustom } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 450px;
    margin: auto;
    padding: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
  }
`;

export const Text = styled(TextCustom.Bold)``;

export const Link = styled.a`
  margin-top: 10px;
`;
